import {Component, Inject, Injector, OnInit} from '@angular/core';
import {ImageCroppedEvent} from 'ngx-image-cropper';
import {PomodoroRepository} from '../../Models/PomodoroRepository';
import {UserService} from '../../services/user.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DialogData} from '../../setting/setting.component';

@Component({
  selector: 'app-image-editor',
  templateUrl: './image-editor.component.html',
  styleUrls: ['./image-editor.component.css']
})
export class ImageEditorComponent implements OnInit {
  public step1 = true;
  public step2 = false;
  public step3 = false;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  fileToUpload: File = null;
  public showEditPic = false;
  public pomodoroRepository: PomodoroRepository;
  public user = {
    name: '',
    email: '',
    mobile: '',
    profile_photo_url: '',
    profile_photo: ''
  };
  public uploadSpinner = false;
  constructor(injector: Injector,
              private userService: UserService,
              public dialogRef: MatDialogRef<ImageEditorComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }

  ngOnInit(): void {
    this.getCurrentUser();
    this.step1 = true;
  }
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.step1 = false;
    this.step2 = true;
    this.step3 = false;
  }

  imageCropped(event: ImageCroppedEvent): any {
    this.pomodoroRepository.profilePhoto = event.base64;
    this.user.profile_photo = event.base64;
  }

  imageLoaded(): any {
    // show cropper
  }

  cropperReady(): any {
    // cropper ready
  }

  loadImageFailed(): any {
    // show message
  }
  updateProfileWithImg(): any {
    this.uploadSpinner = true;
    this.userService.updateProfileWithImg(this.user).subscribe(
      (data) => {
        console.log(data);
        this.uploadSpinner = false;
        this.pomodoroRepository.profilePhoto = data.data.profile_photo_url;
        this.pomodoroRepository.editCtrl = false;
        localStorage.setItem('username', this.user.name);
        this.dialogRef.close();
      },
    );
  }
  getCurrentUser(): any {
    this.userService.getCurrentUserInfo().subscribe(
      (data) => {
        this.user.mobile = data.mobile;
        this.user.name = data.name;
        this.user.email = data.email;
        this.pomodoroRepository.editCtrl = true;
      }
    );
  }
}
